<template>
    <div class="chart-box container">
      <el-row :gutter="20">
        <el-col :span="6" class="results-left">
          <el-card class="box-card department-card">
            <div slot="header" class="clearfix">
              <span>推荐阅读</span>
            </div>
            <div :span="12" v-for="(item,index) in irStaticDisses" :key="item.id" class="item text">
              <router-link class="recommend" tag="a" target="_blank" :to="{path:'details',query:{baseId:item.id,baseType:item.baseType}}">
                {{index+1}}.{{item.title}}
              </router-link>
            </div>
          </el-card>
					<el-card class="box-card" style="margin-top: 20px">
					  <div slot="header" class="clearfix">
					    <span>文献作者</span>
					  </div>
					  <el-row class="text item" style="font-weight: bold">
					    <el-col :span="18">
					      姓名
					    </el-col>
					    <el-col :span="6">
					      成果量
					    </el-col>
					  </el-row>
					  <el-row v-for="item in authorList" :key="item.userId">
					    <el-col :span="18">
					      <router-link class="recommend" :to="{path:'personal',query:{id:item.userId}}">
					        {{item.author}}
					      </router-link>
					    </el-col>
					    <el-col :span="6">
					      {{item.dissNum}}
					    </el-col>
					  </el-row>
					</el-card>
        </el-col>
        <el-col :span="18">
          <el-row class="type-opr">
            <el-col :span="24" style="text-align: right">
              <span class="span-num">下载量：{{irStaticDiss.downloadNum}}  </span>
              <span class="span-num">浏览量：{{irStaticDiss.scanNum}}</span>
              <el-button type="primary" size="medium" plain icon="el-icon-bottom" @click="changDown" v-if="url">全文下载</el-button>
              <el-button type="disable" size="medium" plain v-else>暂无全文</el-button>
            </el-col>
          </el-row>
          <el-card class="box-card">
            <div slot="header" class="clearfix">
              <span>基本信息</span>
            </div>
            <div class="talent-info" v-if="title=='论文详情'">
              <p><b>论文名称：</b>{{irStaticDiss.title}}</p>
              <p><b>文献作者：</b>{{irStaticDiss.author}}</p>
              <p><b>通讯作者：</b>{{irStaticDiss.coAuthors}}</p>
              <p><b>所属部门：</b>{{irStaticDiss.deptName}}</p>
            </div>
            <div class="talent-info" v-if="title=='专利详情'">
              <p><b>专利名称：</b>{{irPatent.title}}</p>
              <p><b>发明人：</b>{{irPatent.inventor}}</p>
              <p><b>所属部门：</b>{{irPatent.deptName}}</p>
            </div>
          </el-card>
          <el-card class="box-card" style="margin-top: 10px;">
            <div slot="header" class="clearfix">
              <span>{{title}}</span>
            </div>
            <div class="talent-info" v-if="title=='论文详情'">
              <p><b>收录情况：</b>{{irStaticDiss.includeInfo}}</p>
              <p><b>年：</b>{{irStaticDiss.year}}</p>
              <p><b>卷：</b>{{irStaticDiss.njqName}}</p>
              <p><b>期：</b>{{irStaticDiss.issn}}</p>
              <p><b>页(文献号)：</b>{{irStaticDiss.page}}</p>
              <p><b>摘要：</b>{{irStaticDiss.summary}}</p>
              <p><b>关键词：</b>{{irStaticDiss.keywords}}</p>
              <p><b>刊名：</b>{{irStaticDiss.journalName}}</p>
              <p><b>PMID：</b>{{irStaticDiss.issn}}</p>
              <p><b>doi：</b>{{irStaticDiss.subjectCode}}</p>
              <p><b>基金：</b>{{irStaticDiss.amountMoney}}</p>
              <p><b>备注：</b>{{irStaticDiss.unitsubjectCode}}</p>
            </div>
            <div class="talent-info" v-if="title=='专利详情'">
              <p><b>所属学科：</b>{{irPatent.subjectCodeName}}</p>
              <p><b>公开号：</b>{{irPatent.publicNo}}</p>
              <p><b>专利号：</b>{{irPatent.applyNo}}</p>
              <p><b>发明/设计人：</b>{{irPatent.inventor}}</p>
              <p><b>申请/专利权人：</b>{{irPatent.agent}}</p>
              <p><b>代理人：</b>{{irPatent.agent}}</p>
              <p><b>专利代理机构：</b>{{irPatent.agency}}</p>
              <p><b>申请日：</b>{{irPatent.gmtApply}}</p>
              <p><b>公告日：</b>{{irPatent.gmtPublic}}</p>
              <p><b>关键词：</b>{{irPatent.keywords}}</p>
              <p><b>主权项：</b>{{irPatent.mainclain}}</p>
              <p><b>专利类别：</b>{{irPatent.typeName}}</p>
              <p><b>主分类号：</b>{{irPatent.patentTypeno}}</p>
              <p><b>摘要：</b>{{irPatent.showClaim}}</p>
            </div>
          </el-card>
        </el-col>
      </el-row>
    </div>
</template>

<script>
		import axios from 'axios';
    export default {
        name: "index",
        data(){
            return{
                activeName: 'second',
								irStaticDisses:[],
								authorList:[],
                irStaticDiss:{},
                irPatent:{},
                URL:'',
                title:"论文详情",
            }
        },
        methods:{
						getDetails(data){
							let currThis=this;
							axios({
							   method: 'get',
							   url: '/api/Achieve/achievement-show/'+data.baseId+'/'+data.baseType+'/1'
								 //url: '/api/Achieve/achievement-show/446/irJournalDiss/1'
							}).then(function (response) {
                currThis.irStaticDisses=response.data.data.irStaticDisses;
                currThis.url = response.data.data.url
								currThis.authorList=response.data.data.authorList;
                if(data.baseType=="irJournalDiss"||data.baseType=="irForeginDiss"){
                  currThis.irStaticDiss=response.data.data.irStaticDiss
                  currThis.title="论文详情";
                }else if(data.baseType=="irPatent"){
                  currThis.irPatent=response.data.data.irPatent;
                  currThis.title="专利详情";
                }
							}).catch(function (thrown) {
							    console.log(thrown)
							});
						},
						changDown(){
							let currThis=this;
							axios({
							   method: 'post',
								 url: '/api/Achieve/changeDownNum/'+this.$route.query.baseId,
							}).then(function (response) {
							    console.log(response);
									currThis.irStaticDiss.downloadNum = currThis.irStaticDiss.downloadNum+1
							}).catch(function (thrown) {
							    console.log(thrown)
							});
						}
        },
        mounted() {
						this.getDetails(this.$route.query);
        }

    }
</script>

<style>

</style>



// WEBPACK FOOTER //
// src/pages/details.vue